import { render, staticRenderFns } from "./testReviewer.vue?vue&type=template&id=41658ff8&scoped=true&"
import script from "./testReviewer.vue?vue&type=script&lang=js&"
export * from "./testReviewer.vue?vue&type=script&lang=js&"
import style0 from "./testReviewer.vue?vue&type=style&index=0&id=41658ff8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41658ff8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41658ff8')) {
      api.createRecord('41658ff8', component.options)
    } else {
      api.reload('41658ff8', component.options)
    }
    module.hot.accept("./testReviewer.vue?vue&type=template&id=41658ff8&scoped=true&", function () {
      api.rerender('41658ff8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/testTaker/testReviewer.vue"
export default component.exports